import { lloFetch } from '../../helpers/lloFetch';
import trans from '../../helpers/trans';
import { FetchResult, FetchResultType } from '../FetchResult';
import { OccupationFilterValues, OccupationOverview, OccupationOverviewResource } from './OccupationOverview';
import { transformToOccupationOverview } from './OccupationOverviewTransformers';

export const getOccupationOverviewApiCall = async (candidateUuid: string, skills: string[], activeFilterValues: OccupationFilterValues): Promise<FetchResult<OccupationOverview, string>> => {
    try {
        const { searchQuery, pageNumber, pageSize } = activeFilterValues;
        const pageOffset = (pageNumber - 1) * pageSize;

        const response = await lloFetch(`/api/competentNLOccupation/Matching?limit=${pageSize}&offset=${pageOffset}`, {
            method: 'POST',
            candidateUuid,
            body: JSON.stringify({
                search: searchQuery,
                skillsToMatch: skills,
            }),
        });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const occupationOverviewResponse: OccupationOverviewResource = await response.json();

        const occupationOverview = transformToOccupationOverview(occupationOverviewResponse);

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: occupationOverview,
        };
    } catch (error) {
        console.error('[getOccupationOverviewApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
